import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isString } from '@motorway/motorway-tools/typeHelpers';
import { c as commonPropTypes } from './commonPropTypes-8c108b82.js';

var styles = {"badge":"vrmBadge-module_badge__2LA5Q","badgeText":"vrmBadge-module_badgeText__1V-vv","badgeWhite":"vrmBadge-module_badgeWhite__2A61x","Badge":"vrmBadge-module_Badge__Mh7yk","badgeSmall":"vrmBadge-module_badgeSmall__lQbMU","badgeRegular":"vrmBadge-module_badgeRegular__2WhSU","badgeLarge":"vrmBadge-module_badgeLarge__28iTJ"};

// eslint-disable-next-line import/no-extraneous-dependencies
const capitalize = str => !isString(str) || !str ? str : str[0].toUpperCase() + str.substr(1).toLowerCase();
const toTitleCase = s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();

/**
  Use this component to render VRM plate / text badge
*/
const VrmBadge = ({
  className,
  size = 'regular',
  vrm = '',
  white = false
}) => /*#__PURE__*/React__default.createElement("span", {
  className: cx(className, styles.badge, {
    [`${styles.badgeWhite}`]: white,
    [styles[`badge${capitalize(size)}`]]: size
  })
}, /*#__PURE__*/React__default.createElement("span", null, vrm));
VrmBadge.propTypes = {
  /**
    Adds class to root container
  */
  className: commonPropTypes.className,
  /**
    Sets VRM Badge size
  */
  size: PropTypes.oneOf(['small', 'regular', 'large']),
  /**
    Sets Badge VRM
  */
  vrm: PropTypes.string,
  /**
    Makes badge white
  */
  white: PropTypes.bool
};

export { VrmBadge as V, styles as s, toTitleCase as t };
